import { render } from "./InvestmentApplication.vue?vue&type=template&id=3509daec"
import script from "./InvestmentApplication.vue?vue&type=script&lang=js"
export * from "./InvestmentApplication.vue?vue&type=script&lang=js"

import "./InvestmentApplication.vue?vue&type=style&index=0&id=3509daec&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__